import { render, staticRenderFns } from "./coplexSet.vue?vue&type=template&id=b42a89fa&scoped=true"
import script from "./coplexSet.vue?vue&type=script&lang=js"
export * from "./coplexSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42a89fa",
  null
  
)

export default component.exports